'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.checkpointIdList = exports.checkpoints = void 0;

exports.checkpoints = {
  firstCheckpoint: {
    challengeId: '66fbe66d4368241d29757851',
    certificateName: '1° Matrícula - Fundamentos da programação front end',
    superOrder: 0,
    phaseOrder: 1,
    order: 1,
    challengeOrder: 1
  },
  secondCheckpoint: {
    challengeId: '648737b64368243e1be3a0e0',
    certificateName: '2° Matrícula - Desenvolvedor Front-end - React',
    superOrder: 2,
    phaseOrder: 7,
    order: 120,
    challengeOrder: 1
  },
  thirdCheckpoint: {
    challengeId: '66688f344368246b87278ce1',
    certificateName:
      '3° Matrícula - React: Navegação e Interatividade Avançadas no Desenvolvimento Web',
    superOrder: 3,
    phaseOrder: 3,
    order: 177,
    challengeOrder: 1
  },
  fourthCheckpoint: {
    challengeId: '66c3495b4368245549b3f2c2',
    certificateName: '4° Matrícula - React com rotas e interações WEB',
    superOrder: 3,
    phaseOrder: 7,
    order: 201,
    challengeOrder: 1
  }
};

exports.checkpointIdList = Object.values(exports.checkpoints).map(
  checkpoint => checkpoint.challengeId
);

/**
 *
 * @param {import("../client/src/redux/prop-types").Challenge} challenge
 * @returns
 */
exports.checkIsCertificateCheckpoint = challenge => {
  return Object.values(exports.checkpoints).some(checkpoint => {
    return (
      challenge.superOrder === checkpoint.superOrder &&
      challenge.phaseOrder === checkpoint.phaseOrder &&
      challenge.order === checkpoint.order &&
      challenge.challengeOrder === checkpoint.challengeOrder
    );
  });
};

/**
 * Returns the checkpoint matching the provided challengeId
 * @param {string} challengeId
 * @returns {Object|null} Matching checkpoint object or null if not found
 */
exports.getCheckpointById = challengeId => {
  return (
    Object.values(exports.checkpoints).find(
      checkpoint => checkpoint.challengeId === challengeId
    ) || null
  );
};

/**
 * Returns the index of the checkpoint matching the provided challengeId
 * @param {string} challengeId
 * @returns {number} Index of the matching checkpoint or -1 if not found
 */
exports.getCheckpointIndexById = challengeId => {
  return Object.values(exports.checkpoints).findIndex(
    checkpoint => checkpoint.challengeId === challengeId
  );
};
